export default __webpack_public_path__ + "static/media/712.5633cd30.png";